import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import BusinessUnit from "@/pages/BusinessUnit";
import Contatti from "@/pages/Contatti";
import AreaRiservata from "@/pages/AreaRiservata";
import DiventaPartner from "@/pages/DiventaPartner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Privacy from "@/pages/Privacy";
import Magazine from "@/pages/Magazine";
import Press from "@/pages/Press";
import { CookieBanner } from "@/components/CookieBanner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-[#080808] min-h-screen">
      <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/business-unit/:id" element={<BusinessUnit />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/diventa-partner" element={<DiventaPartner />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/magazine" element={<Magazine />} />
          <Route path="/press" element={<Press />} />
          <Route path="/area-riservata" element={<AreaRiservata />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <Toaster
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(198,164,93,0.4)",
              color: "#F5F2EB",
            },
          }}
        />
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
